function ModeSelector({ appId, onSelectMode }) {
  const options = [
    {
      mode: "text",
      label: "Chat",
      description: "Type your message",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
    },
    {
      mode: "voice",
      label: "Voice",
      description: "Speak with the concierge",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="23" />
          <line x1="8" y1="23" x2="16" y2="23" />
        </svg>
      ),
    },
  ];

  return (
    <main
      id={"axify__widget-" + appId + "-content"}
      className="axify__widget-content"
    >
      <section
        id={"axify__widget-" + appId + "-mode-selector"}
        className="axify__widget-mode-selector"
      >
        <div className="axify__widget-mode-selector-intro">
          <p>How would you like to connect with our concierge?</p>
        </div>
        <div className="axify__widget-mode-selector-options">
          {options.map((opt) => (
            <button
              key={opt.mode}
              type="button"
              className="axify__widget-mode-option"
              onClick={() => onSelectMode(opt.mode)}
              aria-label={"Start " + opt.label + " mode"}
            >
              <span className="axify__widget-mode-option-icon">
                {opt.icon}
              </span>
              <span className="axify__widget-mode-option-text">
                <span className="axify__widget-mode-option-label">
                  {opt.label}
                </span>
                <span className="axify__widget-mode-option-description">
                  {opt.description}
                </span>
              </span>
              <span className="axify__widget-mode-option-chevron" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </span>
            </button>
          ))}
        </div>
      </section>
    </main>
  );
}

export default ModeSelector;
